module.exports = __webpack_public_path__ + "static/media/blog3.a6fbc0be.jpg";